import * as TipologiaResultado from '../constantes/TipologiaResultado.js';

export const tipoResultadoDe = (resultado) =>
  resultado?.tipoResultado || resultado?.tipo || resultado?.resultadoTipo || null;

const tieneValor = (valor) =>
  valor !== null && valor !== undefined && (typeof valor !== 'string' || valor.trim() !== '');

// Combina dos valores como "primero (segundo)", o el único presente, o null si no hay ninguno.
const formatoConParentesis = (primero, segundo) => {
  if (tieneValor(primero) && tieneValor(segundo)) return `${primero} (${segundo})`;
  if (tieneValor(primero)) return String(primero);
  if (tieneValor(segundo)) return String(segundo);
  return null;
};

// Calcula resultadoLocal/resultadoVisitante del partido según la tipología del resultado
// secundario vigente (TRIBUNAL tiene prioridad sobre PENALES). Devuelve null si ninguna
// tipología especial aplica y por lo tanto no corresponde sobreescribir esos campos.
export const calcularResultadosPartido = (golesLocal, golesVisitante, resultados = []) => {
  const tribunal = (resultados || []).find(
    (item) => tipoResultadoDe(item)?.tipologiaResultado === TipologiaResultado.TRIBUNAL
  );
  if (tribunal) {
    return {
      resultadoLocal: formatoConParentesis(tribunal.golesLocal, tribunal.codResultadoLocal),
      resultadoVisitante: formatoConParentesis(
        tribunal.golesVisitante,
        tribunal.codResultadoVisitante
      ),
    };
  }

  const penales = (resultados || []).find(
    (item) => tipoResultadoDe(item)?.tipologiaResultado === TipologiaResultado.PENALES
  );
  if (penales) {
    return {
      resultadoLocal: formatoConParentesis(golesLocal, penales.golesLocal),
      resultadoVisitante: formatoConParentesis(golesVisitante, penales.golesVisitante),
    };
  }

  return null;
};
